import { useEffect, useState } from "react";
import {
  listarRankingQuebraCabeca,
  listarRankingStop,
  listarRankingTermo,
  listarVitoriasQuebraCabeca,
  listarVitoriasStop,
  listarVitoriasTermo,
} from "../services/ranking.js";

const TERM_MODES = [
  { value: 1, label: "1 Palavra" },
  { value: 2, label: "2 Palavras" },
  { value: 4, label: "4 Palavras" },
];
const PUZZLE_DIFFICULTIES = [3, 4, 5, 6, 7, 8, 16];
const MEDALS = { 1: "🥇", 2: "🥈", 3: "🥉" };

const rankingRequest = ({ game, type, termMode, puzzleDifficulty }) => {
  if (game === "termo") {
    return type === "tempo"
      ? listarRankingTermo(termMode)
      : listarVitoriasTermo(termMode);
  }
  if (game === "quebra-cabeca") {
    return type === "tempo"
      ? listarRankingQuebraCabeca(puzzleDifficulty)
      : listarVitoriasQuebraCabeca(puzzleDifficulty);
  }
  return type === "tempo" ? listarRankingStop() : listarVitoriasStop();
};

function resultLabel(entry, game, type) {
  if (type === "vitorias") {
    const victories = entry.vitorias || 0;
    return `${victories} vitória${victories === 1 ? "" : "s"}`;
  }
  if (game === "termo") {
    return `${entry.tentativas} tentativas · ${entry.tempoSegundos}s`;
  }
  if (game === "stop") {
    return `${entry.acertos}/8 categorias · ${entry.tempoSegundos}s`;
  }
  return `${entry.tempoSegundos}s`;
}

export function RankingPage({ aoVoltar }) {
  const [game, setGame] = useState("termo");
  const [type, setType] = useState("tempo");
  const [termMode, setTermMode] = useState(1);
  const [puzzleDifficulty, setPuzzleDifficulty] = useState(3);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    rankingRequest({ game, type, termMode, puzzleDifficulty })
      .then((values) => active && setEntries(values))
      .catch((error) => {
        console.error("Erro ao buscar ranking:", error);
        if (active) setEntries([]);
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [game, type, termMode, puzzleDifficulty]);

  return (
    <div className="container-sm text-center ranking-page">
      <button className="ranking-back" onClick={aoVoltar} type="button">
        ← Voltar
      </button>
      <h2 className="title">🏆 Ranking Solo</h2>
      <p className="subtitle mb-40">
        Os melhores resultados de quem jogou sozinho.
      </p>

      <div className="ranking-tabs">
        {[
          ["termo", "Termo"],
          ["quebra-cabeca", "Quebra-Cabeça"],
          ["stop", "Stop"],
        ].map(([value, label]) => (
          <button
            className={`btn ${game === value ? "active" : ""}`}
            onClick={() => setGame(value)}
            type="button"
            key={value}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="ranking-tabs ranking-type-tabs">
        <button
          className={`btn ${type === "tempo" ? "active" : ""}`}
          onClick={() => setType("tempo")}
          type="button"
        >
          {game === "stop" ? "🎯 Melhor Resultado" : "⏱️ Melhor Tempo"}
        </button>
        <button
          className={`btn ${type === "vitorias" ? "active" : ""}`}
          onClick={() => setType("vitorias")}
          type="button"
        >
          🔥 Mais Vitórias
        </button>
      </div>

      {(game === "termo" || game === "quebra-cabeca") && (
        <div className="ranking-options">
          {game === "termo"
            ? TERM_MODES.map((mode) => (
                <button
                  className={termMode === mode.value ? "active" : ""}
                  onClick={() => setTermMode(mode.value)}
                  type="button"
                  key={mode.value}
                >
                  {mode.label}
                </button>
              ))
            : PUZZLE_DIFFICULTIES.map((difficulty) => (
                <button
                  className={puzzleDifficulty === difficulty ? "active" : ""}
                  onClick={() => setPuzzleDifficulty(difficulty)}
                  type="button"
                  key={difficulty}
                >
                  {difficulty}x{difficulty}
                </button>
              ))}
        </div>
      )}

      <div className="card ranking-results">
        {loading ? (
          <p className="text-center">Carregando...</p>
        ) : entries.length === 0 ? (
          <p className="text-center">
            Ninguém no ranking ainda. Seja o primeiro!
          </p>
        ) : (
          <ul className="player-list">
            {entries.map((entry, index) => (
              <li className="player-item" key={entry.uid}>
                <div className="ranking-player">
                  <span className="ranking-position">
                    {MEDALS[index + 1] || `${index + 1}º`}
                  </span>
                  {entry.foto && (
                    <img
                      src={entry.foto}
                      alt={entry.nome}
                      width="28"
                      height="28"
                    />
                  )}
                  <span>{entry.nome}</span>
                </div>
                <span className="player-points">
                  {resultLabel(entry, game, type)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
